export default Object.freeze({
  LoadFile: 'upload-file',
  DownloadFile: 'download-file',
});
